import { SET_GET_USER_INFO, SET_IS_EMAIL_REGISTER } from '../constants';

export const setUserInfo = value => dispatch => {
  dispatch({
    type: SET_GET_USER_INFO,
    payload: value,
  });
};

export const setIsEmailRegister = value => dispatch => {
  dispatch({
    type: SET_IS_EMAIL_REGISTER,
    payload: value,
  });
};
